import { useEffect } from 'react';
import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import styles from './EditorExtension_AlbumEmbed.module.css';
//import { useCCContext } from '../CC/CCContext';
//import { CC } from '../CC/CC';
//import * as ccUtils from '../CC/utils';
//import { generateQuery, postWithCache } from '../CC/utils';
import AlbumViewer from './AlbumViewer';

/*
const cssStringToObject = (cssString) => {
  return cssString.split(';').reduce((acc, style) => {
    if (style.trim()) {
      let [property, value] = style.split(':').map(str => str.trim());

      // Convert kebab-case to camelCase
      property = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

      // Handle numeric values
      if (!isNaN(value) && value.trim() !== '') {
        value = Number(value);
      }

      acc[property] = value;
    }
    return acc;
  }, {});
};
*/
export default Node.create({
  name: 'reactComponentAlbumEmbed',
  group: 'inline',
  inline: true,
  atom: true,

  addOptions() {
    return {
      ancestors: [], // Store the chain of parent album IDs
    }
  },

  addAttributes() {
    return {
      selected: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-selected') === 'true',
        renderHTML: (attributes) => ({
          'data-selected': attributes.selected
        }),
      },
      state: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-state'),
        renderHTML: (attributes) => ({
          'data-state': attributes.state
        }),
      },
      query: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-query'),
        renderHTML: (attributes) => ({
          'data-query': attributes.query
        }),
      },
      htmlStyle: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-html-style'),
        renderHTML: (attributes) => ({
          'data-html-style': attributes.htmlStyle
        }),
      },
      linkText: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-link-text'),
        renderHTML: (attributes) => ({
          'data-link-text': attributes.linkText
        }),
      },
      linkAlbumId: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-link-album-id'),
        renderHTML: (attributes) => ({
          'data-link-album-id': attributes.linkAlbumId
        }),
      },
      ancestors: {
        default: [],
        parseHTML: (element) => {
          const ancestorsAttr = element.getAttribute('data-ancestors');
          return ancestorsAttr ? JSON.parse(ancestorsAttr) : [];
        },
        renderHTML: (attributes) => ({
          'data-ancestors': JSON.stringify(attributes.ancestors)
        }),
      }
    }
  },

  parseHTML() {
    return [{ tag: 'AlbumEmbed' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['AlbumEmbed', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});

const Component = (props) => {
  //const ctx = useCCContext();
  //const { cc, setCc, first, setFirst, setSelectedRecord, clearSearch } = ctx;
  const { selected, updateAttributes } = props;
  const { linkAlbumId } = props.node.attrs;
  //const componentRef = useRef({});

  // Get ancestors from extension options or props
  const ancestors = props.extension.options.ancestors || [];
  // Create new ancestors array with current albumId
  const currentAncestors = ancestors;

  useEffect(() => {
    const handleSelection = () => {
      updateAttributes({ selected: props.editor.isActive('reactComponentAlbumEmbed') });
    };
    props.editor.on('selectionUpdate', handleSelection);
    return () => {
      props.editor.off('selectionUpdate', handleSelection);
    };
  }, [props.editor, updateAttributes]);

  const handleDoubleClick = (event) => {
    if (props.editor.isEditable) {
      event.stopPropagation();
      const { state, query, htmlStyle, linkText, linkAlbumId } = props.node.attrs;
      const customEvent = new CustomEvent('showInsertContentPopup', {
        detail: {
          extension: 'AlbumEmbed',
          props: { state, query, htmlStyle, linkText, linkAlbumId },
          pos: props.getPos(),
          node: props.node
        },
        bubbles: true,
        cancelable: true
      });
      event.target.dispatchEvent(customEvent);
    }
  };

  // Check if this album would create a cycle
  const wouldCreateCycle = linkAlbumId && ancestors.includes(linkAlbumId);

  return (
    <NodeViewWrapper as="span" className={`react-component ${selected ? 'selected' : ''}`}>
      <div
        className={styles.hyperlink}
        onDoubleClick={handleDoubleClick}
      >
        {wouldCreateCycle ? (
          <span className="text-red-500">
            Circular reference detected: Album {linkAlbumId} is already in the hierarchy
          </span>
        ) : (
          <AlbumViewer 
            initialAlbumId={linkAlbumId} 
            ancestors={currentAncestors}
          />
        )}
      </div>
    </NodeViewWrapper>
  );
};